/**
 * The five pillars and eight divisions (plan §3.1, §3.3, §4, §9) — static constants, not tables (decision 3).
 *
 * They live in the engine because both the service domain and the browser read them, and the engine is the one
 * dependency-free package both sides already share. Pillar colours are carried over from Alcaraz unchanged and
 * **label pillars only** — they never mean good or bad (plan §2.2).
 */
export const PILLARS = ['GET', 'SELL', 'SERVICE', 'PARTS', 'FINANCE'];
export const DIVISIONS = ['PP', 'LOG', 'MRK', 'SAL', 'CX', 'SER', 'SP', 'FA'];
export const PILLAR_META = {
    GET: {
        label: 'Getting the Vehicles',
        shortLabel: 'Getting',
        codePrefix: 'GET',
        color: '#3E668A',
        tint: '#DCEAF7',
        line: '#C3DAEE',
        divisions: ['PP', 'LOG'],
    },
    SELL: {
        label: 'Selling the Vehicles',
        shortLabel: 'Selling',
        codePrefix: 'SELL',
        color: '#875460',
        tint: '#F3DEE2',
        line: '#E5C9CF',
        divisions: ['MRK', 'SAL', 'CX'],
    },
    SERVICE: {
        label: 'Servicing the Vehicles',
        shortLabel: 'Servicing',
        codePrefix: 'SRV',
        color: '#4F7462',
        tint: '#DDEBE4',
        line: '#C6DCD1',
        divisions: ['SER'],
    },
    PARTS: {
        label: 'Spare Parts',
        shortLabel: 'Spare Parts',
        codePrefix: 'PRT',
        color: '#806B3F',
        tint: '#F3E8CF',
        line: '#E3D3B2',
        divisions: ['SP'],
    },
    FINANCE: {
        label: 'Finance',
        shortLabel: 'Finance',
        codePrefix: 'FIN',
        color: '#675A7D',
        tint: '#E8E1F1',
        line: '#D5CAE6',
        divisions: ['FA'],
    },
};
export const DIVISION_META = {
    PP: { label: 'Product Planning', boardCode: 'PP', pillar: 'GET' },
    LOG: { label: 'Logistics', boardCode: 'LOG', pillar: 'GET' },
    MRK: { label: 'Marketing', boardCode: 'MRK', pillar: 'SELL' },
    SAL: { label: 'Sales', boardCode: 'SAL', pillar: 'SELL' },
    CX: { label: 'Customer Relations & Experience', boardCode: 'CR/CX', pillar: 'SELL' },
    SER: { label: 'Service Centers & Body Shop', boardCode: 'SER/BP', pillar: 'SERVICE' },
    SP: { label: 'Spare Parts', boardCode: 'SP', pillar: 'PARTS' },
    FA: { label: 'Finance & Accounting', boardCode: 'FA', pillar: 'FINANCE' },
};
export const isPillar = (value) => typeof value === 'string' && PILLARS.includes(value);
export const isDivision = (value) => typeof value === 'string' && DIVISIONS.includes(value);
/** The home pillar of a division. */
export const pillarOfDivision = (division) => DIVISION_META[division].pillar;
/** True when `division` reports into `pillar`; a KPI's division must satisfy this. */
export const divisionBelongsTo = (division, pillar) => pillarOfDivision(division) === pillar;
/** Position in the fixed pillar order — the order every list, band and report uses. */
export const pillarRank = (pillar) => PILLARS.indexOf(pillar);
/** Compares two pillars by the fixed pillar order, for `Array.prototype.sort`. */
export const comparePillars = (a, b) => pillarRank(a) - pillarRank(b);
//# sourceMappingURL=pillars.js.map